/**
 * Referral fee calls for the secure link flow (/link/referral-fee): lender-service's @SecureLinkEndpoint endpoints,
 * authorized by the secure link session (Authorization: Bearer). Never sends a loan or broker id: the server takes the
 * loan from the session.
 */
const BASE = '/api/v1/lender/secure-link/referral-fee';

export type SecureLinkRequest = <T>(path: string, init?: RequestInit) => Promise<T>;

/** What the page shows: the broker, and whether its bank details were already sent. */
export interface ReferralFeeLinkData {
  entityName?: string;
  bankInfoStatus?: string;
}

export interface ReferralFeeSignRequest {
  accountName: string;
  routingNumber: string;
  accountNumber: string;
  bankName: string;
  streetName: string;
  city: string;
  zipCode: string;
  state: string;
  signature: string;
  userAgent: string;
}

export class SecureLinkReferralFeeService {
  constructor(private readonly request: SecureLinkRequest) {}

  getData() {
    return this.request<ReferralFeeLinkData>(`${BASE}/data`);
  }

  sign(data: ReferralFeeSignRequest) {
    return this.request(`${BASE}/sign`, { method: 'POST', body: JSON.stringify(data) });
  }
}
